export default "__VITE_ASSET__28472b73__"